import _flowRight from 'lodash/flowRight';
import { normalize } from 'normalizr';
import {
  getNotes,
  createNotes,
  updateNotes,
  deleteNotes,
} from '@homeservices/api-kit/workorder/pronotes';

import { /* JOBS_SCHEMA, */ PRO_WORK_ORDER_MATCHES_SCHEMA } from '@/store/modules/entities';
import { toSnakeCase } from '@/utils/to-snake-case';
import { withRequestLifecycle, REQUEST_LIFECYCLE } from '@/utils/request-lifecycle';

const MUTATION_KEY = 'patchNotes';

const mapNotes = (notes) => {
  const note = notes;
  if (notes.length) {
    note[0].content = notes[0].provider_notes;
  }
  return note;
};
// const reconcileNotesWithinJob = (id, skillsProfile, notes) => ({
//   id,
//   matches: [{ skills_profile: skillsProfile, notes }],
// });
const reconcileWithWorkOrderMatch = (order_hash, entities, notes) => ({
  id: entities[order_hash].matches,
  notes,
});
// const extractNotesFromJob = (jobId, entities) => {
//   const [matchId] = entities.jobs[jobId].matches;

//   return entities.matches[matchId].notes;
// };

const emptyArray = [];

export default {
  state: {
    current: {
      status: REQUEST_LIFECYCLE.UNINITIALIZED,
      error: null,
      result: emptyArray,
    },
  },
  getters: {
    currentJobNotesMeta: (state) => {
      const { result, ...meta } = state.current;

      return meta;
    },
    currentRawJobNotes: state => state.current.result,
  },
  actions: {
    fetchNotes: _flowRight(
      withRequestLifecycle(MUTATION_KEY),
      () => async ({
        rootGetters: {
          'entities/proWorkOrders': proWorkOrderEntity,
        },
      },
        {
          injected: {
            performFulfillment,
          },
          /* jobId , */ params = {},
        }) => {
        const prm = {
          order_hash: params.order_hash,
          service_provider_id: params.service_provider_id,
        };
        const { data } = await getNotes(toSnakeCase(prm));
        const { results } = data;
        if (!results.length) {
          return;
        }

        const reconcile = reconcileWithWorkOrderMatch(
          prm.order_hash, proWorkOrderEntity, mapNotes(results));

        const { entities } = normalize(
          reconcile,
          PRO_WORK_ORDER_MATCHES_SCHEMA
        );

        return performFulfillment({
          entities,
          result: results.map(n => n.id),
          // result: extractNotesFromJob(jobId, entities),
        });
      }
    )(),
    createOrUpdateNotes: _flowRight(
      withRequestLifecycle(MUTATION_KEY),
      () => async ({
        rootGetters: {
          'entities/proWorkOrders': proWorkOrderEntity,
        },
      },
        { injected: { performFulfillment }, noteId, params = {} }) => {
        const prm = {
          order_hash: params.order_hash,
          service_provider_id: params.service_provider_id,
          provider_notes: params.provider_notes,
        };
        const createOrUpdate = noteId
          ? updateNotes.bind(undefined, noteId, { provider_notes: params.provider_notes })
          : createNotes.bind(undefined, prm);

        const { data } = await createOrUpdate(params);

        const reconcile = reconcileWithWorkOrderMatch(
          prm.order_hash, proWorkOrderEntity, mapNotes([data]));

        const { entities } = normalize(
          reconcile,
          PRO_WORK_ORDER_MATCHES_SCHEMA
        );

        return performFulfillment({
          entities,
          result: [data].map(n => n.id),
          // result: extractNotesFromJob(jobId, entities),
        });
      }
    )(),
    deleteNotes: _flowRight(
      withRequestLifecycle(MUTATION_KEY),
      () => async ({
        rootGetters: {
          'entities/proWorkOrders': proWorkOrderEntity,
        },
      }, { injected: { performFulfillment }, order_hash, noteId }) => {
        await deleteNotes(noteId);

        const reconcile = reconcileWithWorkOrderMatch(order_hash, proWorkOrderEntity, emptyArray);

        const { entities } = normalize(
          reconcile,
          PRO_WORK_ORDER_MATCHES_SCHEMA
        );

        return performFulfillment({
          entities,
          result: [noteId],
          // result: extractNotesFromJob(jobId, entities),
        });
      }
    )(),
  },
  mutations: {
    [MUTATION_KEY] (state, payload) {
      state.current = {
        ...state.current,
        ...payload,
      };
    },
  },
};
